export default "__VITE_ASSET__B$gSQsE5__"